import React, { useState, useEffect, useRef, useCallback } from 'react';

const CityAutocomplete = ({ value, onChange, placeholder = "Város keresése...", required = false }) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Load all cities on mount
  useEffect(() => {
    const loadCities = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/cities?limit=1000`);
        if (response.ok) {
          const citiesData = await response.json();
          setCities(citiesData);
        }
      } catch (error) {
        console.error('Error loading cities:', error);
      }
    };

    loadCities();
  }, [backendUrl]);

  // Filter cities based on input
  const handleInputChange = useCallback((inputValue) => {
    onChange(inputValue);
    
    if (inputValue.length >= 1) {
      const filtered = cities.filter(city => 
        city.name.toLowerCase().includes(inputValue.toLowerCase())
      ).slice(0, 50); // Increased limit to show all Budapest districts
      
      setFilteredCities(filtered);
      setShowDropdown(filtered.length > 0);
    } else {
      setFilteredCities([]);
      setShowDropdown(false);
    }
  }, [cities, onChange]);

  const handleCitySelect = (city) => {
    onChange(city.name);
    setShowDropdown(false);
    setFilteredCities([]);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        placeholder={placeholder}
        className="form-input"
        required={required}
        autoComplete="off"
      />
      
      {isLoading && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        </div>
      )}
      
      {showDropdown && filteredCities.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {filteredCities.map(city => (
            <div 
              key={city.id}
              onClick={() => handleCitySelect(city)}
              className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
            >
              <div className="font-medium text-gray-800">{city.name}</div>
              <div className="text-xs text-gray-500">{city.county} megye</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Isolated SearchInput Component

export default CityAutocomplete;
